import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './App.css'
import { Home } from './components/pages/Home/Home'
import Application from './components/organisms/Application'
import PrintPatientCard from './components/pages/PrintPatientCard'
import PrintProfiltCard from './components/pages/PrintProfiltCard'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <div className='App'>
      <ErrorBoundary>
        <BrowserRouter future={{ v7_startTransition: true }}>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/management/*' element={<Application />} />
            <Route exact path='/print/patient' element={<PrintPatientCard />} />
            <Route exact path='/print/profit' element={<PrintProfiltCard />} />
            <Route path='*' element={<Navigate to='/' />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  )
}

export default App
